import { render, staticRenderFns } from "./Gyg.vue?vue&type=template&id=5b70412f&"
import script from "./Gyg.vue?vue&type=script&lang=js&"
export * from "./Gyg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports